import { withNamespaces } from "react-i18next";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from "reactstrap";
import AttachmentCard from "./AttachmentCard";
import { useEffect } from "react";

const UploadingFilesModal = ({
    isOpen,
    toggle,
    uploadingFiles = [],
    downloadUrl,
    t
}) => {

    useEffect(() => {
        if(uploadingFiles.length > 0) {
            const completedItemsCount = uploadingFiles.filter((file) => {
                return [
                    "upload_succeed",
                    "upload_failed"
                ].includes(file.status)
            }).length;

            if(completedItemsCount === uploadingFiles.length) {
                toggle();
            }
        }
    }, [ uploadingFiles ]);

    return (
        <Modal
            isOpen={isOpen}
            centered
            backdrop="static"
        >
            <ModalHeader
                toggle={toggle}
            >
                {t('Uploading files')}…
            </ModalHeader>

            <ModalBody>
                <div className="text-center mb-3">
                    <Spinner />
                    <p className="mt-3 mb-1">
                        {t('Your files are currently being uploaded.')}
                    </p>
                    <p className="text-muted">
                        {t('You can continue typing your message. Sending will be available once uploads are complete.')}
                    </p>
                </div>

                {/* Attachments List */}
                <div className="d-flex flex-column gap-3">
                    {uploadingFiles.map((file, index) => (
                        <AttachmentCard
                            key={index}
                            attachment={file}
                            downloadUrl={downloadUrl}
                            t={t}
                        />
                    ))}
                </div>
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                >
                    {t('Hide')}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default withNamespaces()(
    UploadingFilesModal
);